import { render, staticRenderFns } from "./customerDetall.vue?vue&type=template&id=09078c0b&scoped=true&"
import script from "./customerDetall.vue?vue&type=script&lang=js&"
export * from "./customerDetall.vue?vue&type=script&lang=js&"
import style0 from "./customerDetall.vue?vue&type=style&index=0&id=09078c0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09078c0b",
  null
  
)

export default component.exports